<template>
  <div class="thin-film-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>ΔL = 2nd cosθ$</div>
    </div>

    <div class="main-layout vertical">
      <!-- 渲染区 -->
      <div class="canvas-mixed">
        <svg width="100%" height="240" viewBox="0 0 500 240">
           <!-- 渐变定義 -->
           <defs>
              <linearGradient id="filmGrad" x1="0%" y1="0%" x2="0%" y2="100%">
                 <stop v-for="(c, i) in fringeColors" :key="i" :offset="`${(i/fringeColors.length)*100}%`" :stop-color="c" />
              </linearGradient>
           </defs>
           
           <!-- 肥皂膜 (楔形) -->
           <path d="M 150 20 L 350 20 L 370 220 L 130 220 Z" fill="url(#filmGrad)" opacity="0.8" stroke="rgba(255,255,255,0.2)" />
           
           <!-- 入射光 -->
           <line x1="50" y1="50" x2="160" y2="70" stroke="#fff" stroke-width="2" marker-end="url(#arrow-w)" />
           
           <!-- 测厚计 -->
           <g :transform="`translate(400, ${measureY})`">
              <line x1="-50" y1="0" x2="0" y2="0" stroke="rgba(255,255,255,0.3)" stroke-dasharray="4,2" />
              <text x="5" y="4" fill="#888" font-size="9">厚度 d: {{ currentThickness.toFixed(2) }} nm</text>
           </g>
        </svg>

        <div class="hud-mini">
           <div class="item"><span>光波长 λ:</span> <span class="val">{{ wavelength }} nm</span></div>
        </div>
      </div>

      <!-- 参数控制 -->
      <div class="bottom-controls">
         <div class="control-card glass">
            <div class="row">
               <label>入射光波长 (λ)</label>
               <el-slider v-model="wavelength" :min="400" :max="700" size="mini"></el-slider>
            </div>
         </div>

         <div class="discovery-card">
            <i class="el-icon-magic-stick"></i>
            <p><strong>干涉原理：</strong>光在薄膜的前、后表面反射。当<strong>路程差</strong>恰好为波长的整数倍时叠加增强。由于皂膜受重力影响下厚上薄，形成了彩色的干涉条纹。</p>
         </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ThinFilmInterferenceViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      wavelength: 550,
      measureY: 100
    }
  },
  computed: {
    currentThickness() { return 100 + (this.measureY / 240) * 400; },
    fringeColors() {
      // Logic: Generate interference colors based on thickness and wavelength
      // For monochromatic, it's bright/dark. For white light, it's spectrum.
      // We simulate white light fringes:
      const colors = [];
      for(let i=0; i<10; i++) {
         const hue = (this.wavelength + i * 20) % 360;
         colors.push(`hsla(${hue}, 70%, 60%, 0.8)`);
         colors.push(`hsla(${hue}, 70%, 40%, 0.3)`);
      }
      return colors;
    }
  }
}
</script>

<style scoped lang="scss">
.thin-film-viz {
  flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden;
}
.viz-header { display: flex; justify-content: space-between; align-items: center; .title { font-size: 1rem; color: #fff; } .formula-chip { color: #2ed573; background: rgba(46,213,115,0.1); padding: 4px 12px; border-radius: 8px; font-weight: bold; } }
.canvas-mixed {
  flex: 1.5; background: #050510; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); overflow: hidden;
  .hud-mini { position: absolute; top: 15px; left: 15px; .val { color: #ffd700; font-weight: bold; } }
}
.bottom-controls { flex: 0.5; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; label { display: block; font-size: 0.7rem; color: #888; margin-bottom: 5px; } }
.discovery-card { background: rgba(46, 213, 115, 0.05); padding: 12px 15px; border-radius: 12px; display: flex; gap: 12px; i { color: #2ed573; font-size: 1.1rem; } p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
